import { useNavigate } from "react-router-dom";

type Props = {
  category: string;
  title: string;
  description: string;
  image: string;
  slug: string;
};

export default function StoryCard({
  category,
  title,
  description,
  image,
  slug,
}: Props) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate(`/success-stories/${slug}?origin=list`)}
      className="block w-full text-left"
    >
      <div className="overflow-hidden rounded-xl bg-white border shadow-sm hover:shadow-md transition">
        <div className="flex flex-col md:flex-row">
          {/* Image */}
          <div className="md:w-64 h-44 md:h-auto overflow-hidden">
            <img
              src={image}
              alt={title}
              className="h-full w-full object-cover"
            />
          </div>

          {/* Content */}
          <div className="flex flex-col justify-between p-6">
            <div>
              {/* Category */}
              <span className="inline-block text-xs font-medium text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
                {category}
              </span>



              {/* Title */}
              <h3 className="mt-3 text-xl font-semibold text-gray-900 leading-snug">
                {title}
              </h3>

              {/* Description */}
              <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                {description}
              </p>
            </div>

            {/* CTA */}
            <span className="mt-4 inline-block text-sm font-medium text-blue-600">
              Read Case Study →
            </span>
          </div>
        </div>
      </div>
    </button>
  );
}
